import { fetchApi } from "../../config/fetchConfig";

export const fetchAssignedOrganizationsForExternalApi = (userId) => (dispatch, getState) => {
    const queriesBody = {
        query: `query($userId: Int!) {
            assignedOrganizationsForExternalApi(userId: $userId) {
                id
                name
            }
        }`,
        variables: { userId: Number(userId) },
    };

    return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => {
            if (res.errors?.length) {
                throw new Error(res.errors[0].message);
            }
            return res.data?.assignedOrganizationsForExternalApi || [];
        });
};

export const fetchExternalApiPackages = () => (dispatch, getState) => {
    const queriesBody = {
        query: `query {
            externalApiPackages {
                id
                name
            }
        }`,
    };

    return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => {
            if (res.errors?.length) {
                throw new Error(res.errors[0].message);
            }
            return res.data?.externalApiPackages || [];
        });
};

export const fetchExternalApplicationByEmail = (email) => (dispatch, getState) => {
    const queriesBody = {
        query: `query($email: String!) {
            externalApplicationByEmail(email: $email) {
                id
                email
                apiKey
                isDisable
                packageId
                organizationIds
                createdAt
            }
        }`,
        variables: { email },
    };

    return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => {
            if (res.errors?.length) {
                throw new Error(res.errors[0].message);
            }
            return res.data?.externalApplicationByEmail || null;
        });
};

export const createExternalApplicationCredentials =
    ({ email, packageId, organizationIds, sourceUserId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($input: CreateExternalApplicationCredentialsInput!) {
                createExternalApplicationCredentials(input: $input) {
                    id
                    email
                    apiKey
                    apiSecret
                    organizationIds
                }
            }`,
            variables: {
                input: {
                    email,
                    packageId: Number(packageId),
                    organizationIds: organizationIds.map(Number),
                    sourceUserId: Number(sourceUserId),
                },
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                if (res.errors?.length) {
                    throw new Error(res.errors[0].message);
                }
                const payload = res.data?.createExternalApplicationCredentials;
                if (!payload) {
                    throw new Error("Failed to create External API credentials");
                }
                return payload;
            });
    };

export const associateExternalApplicationOrganization =
    ({ email, organizationId, sourceUserId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($email: String!, $organizationId: Int!, $sourceUserId: Int!) {
                associateExternalApplicationOrganization(
                    email: $email
                    organizationId: $organizationId
                    sourceUserId: $sourceUserId
                ) {
                    id
                    email
                    apiKey
                    isDisable
                    packageId
                    organizationIds
                    createdAt
                }
            }`,
            variables: {
                email,
                organizationId: Number(organizationId),
                sourceUserId: Number(sourceUserId),
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                if (res.errors?.length) {
                    throw new Error(res.errors[0].message);
                }
                const payload = res.data?.associateExternalApplicationOrganization;
                if (!payload) {
                    throw new Error("Failed to associate organization");
                }
                return payload;
            });
    };

export const disassociateExternalApplicationOrganization =
    ({ email, organizationId, sourceUserId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($email: String!, $organizationId: Int!, $sourceUserId: Int!) {
                disassociateExternalApplicationOrganization(
                    email: $email
                    organizationId: $organizationId
                    sourceUserId: $sourceUserId
                ) {
                    id
                    email
                    apiKey
                    isDisable
                    packageId
                    organizationIds
                    createdAt
                }
            }`,
            variables: {
                email,
                organizationId: Number(organizationId),
                sourceUserId: Number(sourceUserId),
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                if (res.errors?.length) {
                    throw new Error(res.errors[0].message);
                }
                const payload = res.data?.disassociateExternalApplicationOrganization;
                if (!payload) {
                    throw new Error("Failed to remove organization association");
                }
                return payload;
            });
    };
